/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable prettier/prettier */
import React, { useRef, useState } from 'react';
import Page from 'components/custom/template/Page';
import useShowModal from 'hooks/custom/useShowModal';
import LeaveReviewModal from 'views/hrms/leave/LeaveReviewModal';
import {
  UilClock,
  UilUserCheck,
  UilUsersAlt,
  UilUserTimes
} from '@iconscout/react-unicons';
import LeaveStatics from 'views/hrms/leave/LeaveStatics';
import CreateLeavePage from 'views/hrms/leave/CreateLeavePage';
import useManagePageLoading from 'hooks/custom/useManagePageLoading';
import apiEndpoints from 'constants/apiEndpoints';
import useFetchData from 'hooks/custom/useFetchData';
import Button from 'components/base/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { Dropdown, ButtonGroup } from 'react-bootstrap';
import CheckManualPunchColumns from './CheckManualPunchColumns';
import ConfirmationModal from '../ConfirmationModal';

const CheckManualPunch = () => {
  // const dummyData = [
  //   {
  //     employee_name: 'John Doe',
  //     employee_mobile: '9876543210',
  //     department_name: 'IT',
  //     shift_name: 'Morning Shift',
  //     shift_time: '9:00 AM - 5:00 PM',
  //     employee_id: 1,
  //     punchInTime: '2025-02-25T10:21:12.000000Z',
  //     punchOutTime: '2025-02-25T11:21:12.000000Z',
  //     shift_end_time: '11:12',
  //     shift_start_time: '04:00'
  //   },
  //   {
  //     employee_name: 'Jane Smith',
  //     employee_mobile: '8765432109',
  //     department_name: 'HR',
  //     shift_name: 'Evening Shift',
  //     shift_time: '2:00 PM - 10:00 PM',
  //     employee_id: 2,
  //     punchInTime: '2025-02-25T10:21:12.000000Z',
  //     punchOutTime: '2025-02-25T11:21:12.000000Z',
  //     shift_end_time: '11:12',
  //     shift_start_time: '04:00'
  //   },
  //   {
  //     employee_name: 'Michael Johnson',
  //     employee_mobile: '7654321098',
  //     department_name: 'Finance',
  //     shift_name: 'Night Shift',
  //     shift_time: '10:00 PM - 6:00 AM',
  //     employee_id: 3,
  //     punchInTime: '2025-02-25T10:21:12.000000Z',
  //     punchOutTime: '2025-02-25T11:21:12.000000Z',
  //     shift_end_time: '11:12',
  //     shift_start_time: '04:00'
  //   },
  //   {
  //     employee_name: 'Emily Davis',
  //     employee_mobile: '6543210987',
  //     department_name: 'Operations',
  //     shift_name: 'Morning Shift',
  //     shift_time: '8:00 AM - 4:00 PM',
  //     employee_id: 4,
  //     punchInTime: '2025-02-25T10:21:12.000000Z',
  //     punchOutTime: '2025-02-25T11:21:12.000000Z',
  //     shift_end_time: '11:12',
  //     shift_start_time: '04:00'
  //   },
  //   {
  //     employee_name: 'Robert Brown',
  //     employee_mobile: '5432109876',
  //     department_name: 'Marketing',
  //     shift_name: 'Afternoon Shift',
  //     shift_time: '12:00 PM - 8:00 PM',
  //     employee_id: 5,
  //     punchInTime: '2025-02-25T10:21:12.000000Z',
  //     punchOutTime: '2025-02-25T11:21:12.000000Z',
  //     shift_end_time: '11:12',
  //     shift_start_time: '04:00'
  //   }
  // ];

  const [pageLoading, loadingMessage, handleLoading] = useManagePageLoading();
  const [leaveData] = useFetchData(apiEndpoints.leave.getAll);

  const refreshDataRef = useRef(null);
  const reviewModal = useShowModal(false);

  const handleRefresh = () => {
    if (refreshDataRef.current) {
      refreshDataRef.current();
    }
  };
  const handleRefreshDataRegister = refreshData => {
    refreshDataRef.current = refreshData;
  };

  const handleShowReview = data => {
    reviewModal.handleOpenModal(data);
  };
  return (
    <>
      <Page
        title={'Check Manual Punch'}
        tableColumn={{
          column: CheckManualPunchColumns({ handleShowReview }),
          actions: null
        }}
        // dummyData={dummyData}
        urlEndPoint={apiEndpoints.employee.ManualPunchCheckList}
        exportName="manual punch"
        backdrop={{ message: loadingMessage, loading: pageLoading }}
        onRegisterRefresh={handleRefreshDataRegister}
        dataWithDateRange={false}
        dataFormatter={data => data.toReversed()}
      >
        <ConfirmationModal
          show={reviewModal.isOpen}
          handleClose={reviewModal.handleCloseModal}
          data={reviewModal.modalData || {}}
          handleLoading={handleLoading}
          refreshData={handleRefresh}
          action={reviewModal.modalData?.status === 'Pending'}
        />
      </Page>
    </>
  );
};

export default CheckManualPunch;
